import {getBlogArticles} from "../services/newApi";
import {useQuery} from "@tanstack/react-query";

/**
 * Récupère partiellement ou la totalité des articles du blog.
 *
 * @param id L'id de l'article à récupérer, si = 0 on récupère tous les articles.
 * @param fullDatas Si = 0 on récupère des données partielles (pour previews), sinon on récupère tout.
 */
export const useArticlePreviews = () => {
    const {
        isPending,
        data,
        error,
        isError
    } = useQuery({
        queryKey: ["blog-articles-preview"],
        queryFn: async () => getBlogArticles(0, 1),
    });

    return {
        isLoading: isPending,
        articles: data,
        error,
        isError
    };
}